'use client';

/**
 * LandingViewTracker — feuert genau EINEN 'landing_view'-Event beim Mount
 * der oeffentlichen Karriereseite (Gruender 2026-08-03: Karriere-Besucher
 * sichtbar machen).
 *
 * Zaehler-Semantik: EINE Session (= tab) = MAX. EIN landing_view. Damit
 * zaehlen Route-Toggles (client-side navigation) oder Reloads im selben
 * Tab NICHT doppelt. Session-ID kommt aus analytics.ts (sessionStorage).
 * Der Guard steht in sessionStorage — bei neuem Tab neuer Zaehler, wie
 * bei allen anderen Funnel-Events auch.
 *
 * Datenfluss:
 *   Client -> POST /api/v1/funnel/fcp/event  (event_type='landing_view',
 *   utm_* wird automatisch von track() aus der URL gelesen)
 *
 * Aggregation:
 *   /api/v1/admin/analytics/funnel-events liefert daraus die Kennzahl
 *   "Karriere-Besucher" (siehe /admin/statistik/besucher).
 */

import { useEffect } from 'react';
import { track } from '@/app/bewerben/_components/analytics';

const SESSION_GUARD_KEY = 'landing_view_sent_v1';

interface Props {
  /** Tenant-Slug fuer den Ping. Muss zum Backend-Route-Param passen. */
  readonly tenantSlug: string;
}

export default function LandingViewTracker({ tenantSlug }: Props) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      if (sessionStorage.getItem(SESSION_GUARD_KEY) === '1') return;
      sessionStorage.setItem(SESSION_GUARD_KEY, '1');
    } catch {
      // Privatmodus / Quota — dann trackt jeder Route-Toggle. Akzeptabel,
      // besser als nichts zu tracken.
    }
    track(tenantSlug, { event_type: 'landing_view' });
  }, [tenantSlug]);

  return null;
}
